module.exports = __webpack_public_path__ + "img/checkout.d48f20c2.png";